import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import accountDetails from '../fragments/account/accountDetails';
import accountAddresses from '../fragments/account/accountAddresses';

export const getAccountQuery = gql`
  query getAccount {
    me {
      ...accountDetails
      ...accountAddresses
    }
  }
  ${accountDetails}
  ${accountAddresses}
`;

export const getAccountOptions = {
  options: {
    fetchPolicy: 'cache-first',
  },
};

const getAccount = graphql(getAccountQuery, getAccountOptions);

export default getAccount;
